import type { TOC } from '@ember/component/template-only';
import { PrismLoadingBar, PrismMessage } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import GeneralEmbeddedApp from 'lumen/components/general/embedded-app';
import type MarketCustomReportingExploreController from 'lumen/controllers/market/custom-reporting/explore';

interface MarketCustomReportingExploreSignature {
  Args: {
    controller: MarketCustomReportingExploreController;
    model: unknown;
  };
}

<template>
  <div class="embed-container">
    {{#if @controller.embedError}}
      <div
        class="flex h-full w-full items-center justify-center"
        data-test-id="embed-acquire-error"
      >
        <PrismMessage
          @description={{t "general.error"}}
          @illustration="100x100_critical"
          @title={{t "general.error_title"}}
        />
      </div>
    {{else if @controller.embedUrl}}
      <GeneralEmbeddedApp
        @baseURL={{@controller.ajax.host}}
        @id="looker-embed"
        {{! @glint-expect-error: Incorrect type }}
        @onMessage={{@controller.onMessage}}
        @url={{@controller.embedUrl}}
      />
    {{else}}
      <div class="loading-bar-container" data-test-id="embed-acquire-loading">
        <PrismLoadingBar />
      </div>
    {{/if}}
  </div>
</template> satisfies TOC<MarketCustomReportingExploreSignature>;
